import api_all from './api'

export default {
    api_all
}


//////////////////
// WEBPACK FOOTER
// ./api/index.js
// module id = null
// module chunks = 